<h1 mat-dialog-title>{{ data?.title }}</h1>
<div class="info-modal-text" mat-dialog-content>
  @if (data?.text) {
    <p>{{ data?.text }}</p>
  }
  @if (data?.html) {
    <p [innerHtml]="data?.html | safeHtml"></p>
  }
</div>
<div class="info-modal-actions" mat-dialog-actions align="end">
  <button semerisButton variant="raised" mat-dialog-close color="accent">Ok</button>
</div>
